export default __webpack_public_path__ + "images-processed/dpd-01673578b698870793466c13c6771c2d.png";